import { API } from "../../../config";
import { LIST_LIMIT } from "../../../constants/constants";
import { ProductVariationWithPaginationType, SearchedNonVariationProductsWithPagination, VariationDetailsItemType } from "../../../interfaces/productVariationInterface";
import AxiosUtils from "../../../utils/AxiosUtils";
import Cookies from "../../../utils/Cookies";
import { serverAPIPath, mockAPIPath } from "../config/apiPath";
class ProductVariationApi {
    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;
    then: any;
    
    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = { "access-token": new Cookies("access-token").read() };
    }

    async productVariationListData(
        page: number, 
        search?: string, 
        limit = LIST_LIMIT.EXHIBITION_USER_LIST_LIMIT,
        order?:string,
        column?:string,
    ) {
        const response = this.isHitDummyURL ?
            await new AxiosUtils(`${mockAPIPath.VARIATION_LIST}`, this.payload).get() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.VARIATION_LIST}?&page=${page}&limit=${limit}&search=${search}&order=${order}&column=${column}`, this.payload,this.headers).get();
        if (response?.data?.success) {
            const { currentPage, totalPages, currentTotalCount, totalCount} = response.data.data;
            const productVariationData: ProductVariationWithPaginationType  = {
                productVariationLogs: response.data.data.data,
                pagination: {
                    totalPages,
                    currentPage,                  
                    currentTotalCount,
                    totalCount,
                },
            };
            return productVariationData;
        }else if(response?.success == false){
            throw new Error(response?.message);
        }else{
            throw new Error(response);
        }
    }
    async variationDetails(variationGroupId:number) {
        const response = this.isHitDummyURL ?
            await new AxiosUtils(`${mockAPIPath.VARIATION_LIST}`, this.payload).get() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.VARIATION_LIST}/${variationGroupId}`, this.payload,this.headers).get();
        if (response?.data?.success) {
            const productVariationData: VariationDetailsItemType  = {
                variationDetailsLogs: response.data.data.products,
            };
            return productVariationData;
        }else if(response?.success == false){
            throw new Error(response?.message);
        }else{
            throw new Error(response);
        }
    }
    async searchNonVariationProducts(page: number, search?: string, limit = LIST_LIMIT.EXHIBITION_USER_LIST_LIMIT) {
        const response = this.isHitDummyURL ?
            await new AxiosUtils(`${mockAPIPath.PRODUCT_LIST_SEARCH}`, this.payload).get() :
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.PRODUCT_LIST_SEARCH}?page=${page}&limit=${limit}&search=${search}`, this.payload,this.headers).get();
        if (response?.data?.success) {
            const { currentPage, totalPages, currentTotalCount, totalCount} = response.data;
            const searchedProductsData: SearchedNonVariationProductsWithPagination  = {
                searchedProducts: response.data.data.products,
                pagination: {
                    totalPages,
                    currentPage,
                    currentTotalCount,
                    totalCount,
                },
            };
            return searchedProductsData;
        }else if(response?.success == false){
            throw new Error(response?.message);
        }else{
            throw new Error(response);
        }
    }

    async addProductVariation(){
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ? 
            await new AxiosUtils(mockAPIPath.EDIT_PRODUCT_VARIATION, this.payload).get() : 
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.EDIT_PRODUCT_VARIATION}`, this.payload,this.headers).post(true);
        let isEditProductVariationDetail : string;
        if(response?.data?.success==true) {
            isEditProductVariationDetail = response?.data?.message;
            return isEditProductVariationDetail;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        }
    }

    async editProductVariation(variationGroupId : number) {
        const response = this.isHitDummyURL && API.HIT_DUMMY_URL ? 
            await new AxiosUtils(mockAPIPath.EDIT_PRODUCT_VARIATION, this.payload).put() : 
            await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.EDIT_PRODUCT_VARIATION}/${variationGroupId}`, this.payload,this.headers).put(true);
        
        if(response?.data?.success==true) {
            return response?.data?.message;
        }
        else if(response?.success == false)
        {   
            throw new Error(response?.message);        
        }else{
            throw new Error(response);
        }
    }
}

export default ProductVariationApi;